import type { FeatureModalConfig } from '@/components/ui/feature-modal';
import { Shield, Zap } from 'lucide-react';

export const trainingAnnouncementConfig: FeatureModalConfig & {
  endDate?: number;
} = {
  title: 'Training mode release!',
  description:
    'We just launched the beta version of our new training modes. Check them out!',
  features: [
    {
      text: 'Defend sites vs realistic bots',
      icon: Shield,
    },
    {
      text: 'High stakes prefire trainer',
      icon: Zap,
    },
  ],
  videoSrc: 'https://www.youtube.com/embed/Si2BbeJfB6g?si=R2gmj91QkQF39Z9o',
  thumbnailSrc: '/images/training-prefire.png',
  thumbnailText: 'Introduction: Training',
  buttonText: 'Get started',
  endDate: 1756553817,
};
